/**
 * Product visibility rules for the admin booking screens.
 *
 * check_availability_enhanced only checks product_types.active for pool
 * products, so individual items of an inactive product type still come back.
 * The admin pick lists drop inactive product types here. Hidden products stay
 * bookable by staff (hidden only keeps them out of the customer shop) and are
 * shown with a badge instead.
 *
 * Filter only the lists staff pick from: bundles and scanned units still look
 * up their components in the unfiltered availability data.
 */

export interface ProductVisibilityFlags {
  active: boolean | null;
  hidden: boolean | null;
}

/** NULL counts as active, matching the column default. */
export function isActiveProduct(flags: Pick<ProductVisibilityFlags, 'active'> | null | undefined): boolean {
  return flags?.active !== false;
}

/** NULL counts as not hidden, matching the column default. */
export function isHiddenProduct(flags: Pick<ProductVisibilityFlags, 'hidden'> | null | undefined): boolean {
  return flags?.hidden === true;
}
